import { Amplitude } from './amplitude'
import { HotJar } from './hotjar'

const Analytics = {
  AMP: Amplitude,
  HotJar,
}
export default Analytics
